<div class="custom-domain-table-container" [class.pointed]="status === 'active'">
  <div class="table-header">
    <div class="title">Domain name</div>
    <div class="title">Status</div>
    <div class="title" *ngIf="status === 'active'">SSL</div>
    <div class="title">Nameservers</div>
    <div class="title more" *ngIf="status !== 'active'"></div>
  </div>
  <div class="divider"></div>
  <div class="table-body">
    <div class="table-item title">{{domain}}</div>
    <div class="table-item status">
      @if(loading) {
      <img src="assets/images/loading/spinner-dotted.svg">
      <div class="generating">Checking</div>
      }@else {
      <div class="dot" [class.active]="pointed"></div>
      {{pointed ? 'Pointed' : 'Not pointed'}}
      }
      <div class="divider"></div>
      <i class="db-icon db-icon-ds-restore mr8" [class.disabled]="loading"></i>
      <span [class.disabled]="loading" (click)="checkStatus()">Recheck status</span>
    </div>
    <div class="table-item ssl-status" *ngIf="status === 'active'">
      <div class="dot" [class.active]="status === 'active'"></div>
        {{ 'text_activeSsl' | dbText }}
    </div>
    <div class="table-item nameserver-link" [class.disabled]="loading"><span (click)="openNameservers.emit()">View nameservers</span></div>
    <div class="table-item more" *ngIf="status !== 'active'">
      <a class="dropdown" (click)="openTooltip = true">
        <i class="db-icon db-icon-ds-more-l"></i>
      </a>
      <div class="ds-dropdown-list" *ngIf="openTooltip" (dbClickOutside)="openTooltip=false">
        <div (click)="onRemove()" class="ds-dropdown-list__content">
          <div>Remove</div>
        </div>
      </div>
    </div>
  </div>
</div>
